module.exports = __webpack_public_path__ + "static/aquila-favonia-dc6940ba198d9c4a19478d030c942e43.png";